import { cn } from '@/lib/utils';

type ChevronDownProps = React.ComponentProps<'svg'>;

const ChevronDown = ({ className, ...props }: ChevronDownProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 9"
      fill="none"
      className={cn('w-[15px] h-[9px]', className)}
      {...props}
    >
      <path d="M7.50181 7.25441L0.870277 0H14.1333L7.50181 7.25441Z" fill="var(--muted-foreground)" />
      <path
        d="M0 0L1.02015 1.24685L7.06549 8.50126L7.5 9L7.93451 8.50126L13.9798 1.24685L15 0H0ZM2.92821 1.45088H12.0718L7.5 6.93703L2.92821 1.45088Z"
        fill="var(--muted-foreground)"
      />
    </svg>
  );
};

export default ChevronDown;
